<template>
	<div class="image-example-container">
		<div v-for="(image, i) in imgArr" class="image-example-wrap" :key="i">
			<img :src="image.path" :alt="image.text" :key="i" class="image-example" />
			<p class="image-example-text">{{ image.text }}</p>
		</div>
	</div>
</template>

<script setup lang="ts">
import img1 from '@/resources/images/general-examples/1.jpg'
import img2 from '@/resources/images/general-examples/2.jpg'
import img3 from '@/resources/images/general-examples/3.jpg'
import img4 from '@/resources/images/general-examples/4.jpg'
import img5 from '@/resources/images/general-examples/5.jpg'
import img6 from '@/resources/images/general-examples/6.jpg'

const imgArr = [
	{ path: img1, text: 'Прекрасные горы позади альпийского луга на закате' },
	{ path: img2, text: 'Капибара в костюме, держащая табличку с надписью "Hello World"' },
	{ path: img3, text: 'Реалистичное изображение супергероя который умеет превращаться в бабочку' },
	{ path: img4, text: 'Дельфин выпрыгивает из бокала шампанского' },
	{ path: img5, text: 'Котик с грустными глазами' },
	{ path: img6, text: 'Эльфийка с большой грудью на фоне эльфийского дерева' }
]
</script>

<style lang="scss" scoped>
.image-example {
	width: 100%;
	height: 100%;
	object-fit: cover;
	&-wrap {
		position: relative;
		width: calc(50% - 5px);
		aspect-ratio: 1 / 1;
		border-radius: var(--radius-sm);
		overflow: hidden;
	}
	&-text {
		position: absolute;
		bottom: 0;
		color: var(--text-inverse);
		text-align: center;
		padding: 8px;
		padding-bottom: 16px;
		width: 100%;
		background-color: var(--overlay);
		font: var(--font-body-small);
	}
	&-container {
		width: 100%;
		display: flex;
		align-items: center;
		justify-content: center;
		flex-wrap: wrap;
		gap: 10px;
	}
}
</style>
